import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center">
            精彩花絮
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            幕后故事、深度解读与独家内容
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaData.map((item) => (
              <div
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all"
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/60 text-background-50 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </span>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs font-label">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-900 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                  <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}